import React from 'react';
import { useEffect, useState } from 'react';
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';


const BiassesProducteurs = (props) => {


    const [producteurs, setProducteurs] = useState([]);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);


    useEffect(() => {
        const list = [];
        fetch(`${URL_COURTJUS_BACK}/usersin/${props.bParticipants}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                res.forEach(producteur => { list.push(producteur.uStructure + ' (' + producteur.uNom + ' ' + producteur.uPrenom + ')') });
                setProducteurs(list);
            });
    }, []);


    return (

        <p>{producteurs.map((q, i) => <span className='biasse-list-particip' key={i}>{q}</span>)}</p>

    )
}

export default BiassesProducteurs;